import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, ValidatorFn, Validators } from '@angular/forms';

@Component({
    selector: 'updatecollegeID-dialog-component',
    styleUrls: ['updatecollegeID.dialogcomponent.css'],
    templateUrl: 'updatecollegeID.dialogcomponent.html'
})
export class UpdateCollegeIDDialogComponent implements OnInit {
    title: string;
    message: string;
    inputhint: string;
    oktext: string;
    canceltext: string;
    validators: ValidatorFn[];
    value: string;
    aspassword: boolean;

    inputForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<UpdateCollegeIDDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: _UpdateCollegeIDDialogOptions, private fb : FormBuilder) {
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.inputhint = data.InputHint || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.validators = data.Validators || null;
        this.value = data.Value || null;
        this.aspassword = (data.AsPassword != null ? data.AsPassword : false);
    }

    ngOnInit() {
        // Set up the form group
        this.inputForm = this.fb.group({
            'userinput': [this.value]
        });

        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            let ctrl = this.inputForm.get('userinput');
            let toSet = [Validators.required, ...this.validators];

            ctrl.setValidators(this.validators);
            this.inputForm.updateValueAndValidity();
        }
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        let response = this.inputForm.get('userinput').value;

        this.dialogRef.close(response);
    }
}

// #region Custom Classes

export class _UpdateCollegeIDDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    InputHint?: string;
    Validators?: ValidatorFn[];
    Value?: string;
    AsPassword?: boolean;
}

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/updatecollegeID/updatecollegeID.dialogcomponent.ts